import { render, staticRenderFns } from "./QuickTipsNearMatchByLocation.vue?vue&type=template&id=41d979ee&scoped=true&"
import script from "./QuickTipsNearMatchByLocation.vue?vue&type=script&lang=js&"
export * from "./QuickTipsNearMatchByLocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41d979ee",
  null
  
)

export default component.exports